import { render, staticRenderFns } from "./CategoryEditView.vue?vue&type=template&id=05696a20&scoped=true"
import script from "./CategoryEditView.vue?vue&type=script&lang=js"
export * from "./CategoryEditView.vue?vue&type=script&lang=js"
import style0 from "./CategoryEditView.vue?vue&type=style&index=0&id=05696a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05696a20",
  null
  
)

export default component.exports